import { MonitoringGraphData } from "@services/monitoring/types";
import { DatasetDataItem, LineChartData } from "../types";

const transformData = (
  data: MonitoringGraphData["data"] | undefined
): DatasetDataItem[] => data?.map(([x, y]) => ({ x, y })) ?? [];

export const getDatasets = (
  chartData: MonitoringGraphData[],
  colors: string[]
): LineChartData["datasets"] => {
  return chartData.map((dataItem, index) => ({
    id: dataItem.name,
    label: dataItem.name,
    data: transformData(dataItem.data),
    borderColor: colors[index],
    backgroundColor: colors[index],
  }));
};
